import PropTypes from 'prop-types';
import React from 'react';
import Loader from '@/components/loader/loader-component';
import Styled from './table-button-component-style';

/**
 * Table button component for generic use in Table component.
 * @param {object} props - The component props.
 * @param {string} props.icon - Icon to display in the button.
 * @param {string} props.width - Width of the button.
 * @param {string} props.margin - Margin of the button.
 * @param {Function} props.onClick - Function to call when the button is clicked.
 * @param {string} props.value - Value of the button.
 * @param {string} props.kind - Kind of the button.
 * @param {boolean} props.loading - Loading state of the button.
 * @returns {JSX.Element}
 */
const Button = ({ icon, onClick, value, kind, loading, width, margin }) => {
  const canClick = () => {
    if (!loading) {
      onClick();
    }
  };
  if (loading) {
    return <Loader loading />;
  }
  if (kind === 'secondary') {
    return (
      <Styled.StyledButton
        onClick={canClick}
        value={value}
        secondary
        disabled={loading}
        width={width}
        margin={margin}
      >
        <Styled.Icon>{icon}</Styled.Icon>
        {!loading && value}
        {loading && 'Loading ...'}
      </Styled.StyledButton>
    );
  }
  return (
    <Styled.StyledButton
      onClick={canClick}
      value={value}
      disabled={loading}
      width={width}
      margin={margin}
    >
      <Styled.Icon>{icon}</Styled.Icon>
      {!loading && value}
      {loading && 'Loading ...'}
    </Styled.StyledButton>
  );
};

Button.propTypes = {
  icon: PropTypes.element,
  width: PropTypes.string,
  margin: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  kind: PropTypes.oneOf(['primary', 'secondary']),
  value: PropTypes.string.isRequired,
  /**
   * Display a loader on the button to display a action is in progress.
   */
  loading: PropTypes.bool,
};

Button.defaultProps = {
  kind: 'primary',
  loading: false,
  icon: undefined,
  width: undefined,
  margin: undefined,
};

export default Button;
